import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-label',
  standalone: true,
  templateUrl: './label.component.html',
  styleUrls: ['./label.component.scss']
})
export class LabelComponent implements OnInit {
  @Input() labelText: string | null = null;
  constructor() { }

  ngOnInit(): void {
  }

}
